import axios from "axios";
const customFetch = axios.create({
	headers: {
		"Content-type": "application/json",
	},
	// withCredentials: true,
});

const getTokenFromLocalStorage = () => {
	const auth_user = localStorage.getItem("auth_user");
	const id_token = JSON.parse(auth_user)?.id_token;
	return id_token;
};

const removeTokenFromLocalStorage = () => {
	localStorage.removeItem("auth_user");
};

customFetch.interceptors.request.use(
	(config) => {
		const token = getTokenFromLocalStorage();
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

class Api {
	/**
	 *
	 * @param {String} url
	 * @returns {Object} Either { success: true, data: string } or { success: false, error: string }
	 */
	get = async (url, query) => {
		console.log("GET: ", url);
		try {
			const res = await customFetch.get(url, { params: query });
			return {
				success: true,
				data: res.data,
			};
		} catch (err) {
			if (err.hasOwnProperty("response")) {
				return err.response.data;
			} else {
				return {
					success: false,
					error: err.message,
				};
			}
		}
	};

	/**
	 *
	 * @param {String} url
	 * @param {Object} body
	 * @returns {Object} Either { success: true, data: string } or { success: false, error: string }
	 */
	post = async (url, body) => {
		console.log("POST: ", url);
		try {
			const res = await customFetch.post(url, body);
			return {
				success: true,
				data: res.data,
			};
		} catch (err) {
			if (err.hasOwnProperty("response")) {
				return err.response.data;
			} else {
				return {
					success: false,
					error: err.message,
				};
			}
		}
	};

	/**
	 *
	 * @param {String} url
	 * @param {Object} body
	 * @returns {Object} Either { success: true, data: string } or { success: false, error: string }
	 */
	put = async (url, body) => {
		try {
			const res = await customFetch.put(url, body);
			return {
				success: true,
				data: res.data,
			};
		} catch (err) {
			if (err.hasOwnProperty("response")) {
				return err.response.data;
			} else {
				return {
					success: false,
					error: err.message,
				};
			}
		}
	};

	/**
	 *
	 * @param {String} url
	 * @returns {Object} Either { success: true, data: string } or { success: false, error: string }
	 */
	delete = async (url) => {
		try {
			const res = await customFetch.delete(url);
			return {
				success: true,
				data: res.data,
			};
		} catch (err) {
			if (err.hasOwnProperty("response")) {
				return err.response.data;
			} else {
				return {
					success: false,
					error: err.message,
				};
			}
		}
	};
}

const api = new Api();
export default api;
